var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('club-form',{staticClass:"card card-body rounded-top",attrs:{"edit":true},on:{"updated":_vm.updated}})}
var staticRenderFns = []

export { render, staticRenderFns }